module.exports = __webpack_public_path__ + "static/img/variety_contents_creator.e854b5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/application/variety_contents_creator.svg
// module id = S2Ie
// module chunks = 0